import { Modal, message } from 'antd';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { type InviteCodeApplication, inviteApplicationStore } from '@/stores';
import { WaitlistQuestionnaireView } from './WaitlistQuestionnaireView';

interface ApproveDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  application: InviteCodeApplication | null;
}

export function ApproveDialog({
  open,
  onOpenChange,
  application,
}: ApproveDialogProps) {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!application) return;

    setLoading(true);
    try {
      await inviteApplicationStore.approveAndSendInvite(application.id);
      message.success('审批成功，通知邮件已发送');
      onOpenChange(false);
    } catch (error) {
      console.error('审批失败:', error);
      message.error('审批失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      title="审批并发送通知邮件"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={handleClose}>
            取消
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={loading}
            style={{
              background: 'linear-gradient(135deg, #ff5c5c 0%, #ff7070 100%)',
              color: '#ffffff',
              boxShadow:
                '0 4px 12px rgba(255, 92, 92, 0.4), 0 0 0 1px rgba(255, 92, 92, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
              cursor: loading ? 'not-allowed' : 'pointer',
            }}
            className="hover:opacity-90 hover:shadow-lg transition-all font-semibold"
          >
            {loading ? '处理中...' : '确认发送'}
          </Button>
        </div>
      }
      centered
    >
      {application && (
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label>邮箱</Label>
            <p className="text-sm font-medium text-foreground">
              {application.email}
            </p>
          </div>
          <div className="space-y-2">
            <Label>问卷信息</Label>
            <WaitlistQuestionnaireView
              questionnaire={application.questionnaire}
              rawReason={application.reason}
            />
          </div>
          <p className="text-sm text-muted-foreground">
            确认后将直接开通内测资格，并通过 Amazon SES 发送通知邮件
          </p>
        </div>
      )}
    </Modal>
  );
}
